import { render, staticRenderFns } from "./StoriesStatisticPreviews.vue?vue&type=template&id=0127a71f&scoped=true&"
import script from "./StoriesStatisticPreviews.vue?vue&type=script&lang=ts&"
export * from "./StoriesStatisticPreviews.vue?vue&type=script&lang=ts&"
import style0 from "./StoriesStatisticPreviews.vue?vue&type=style&index=0&id=0127a71f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0127a71f",
  null
  
)

export default component.exports